import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const MessageIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M16.4663 20.1484L16.8333 20.1484L16.8333 17.0929L16.8333 16.5929L17.3333 16.5929L19.5 16.5929L19.5 5.14844L4.5 5.14844L4.5 16.5929L12.4597 16.5929L12.6568 16.5929L12.8009 16.7274L16.4663 20.1484Z"
        stroke={color}
      />
    </svg>
  );
};

export default MessageIcon;
